import FindPwForm from "./FindPwForm";
import FindPwResult from "./FindPwResult";

export { FindPwForm, FindPwResult };

export default { FindPwForm, FindPwResult };
